<template>
  <div ref="layout" class="clipVideo clipVideo_section">
    <div ref="header" class="clipVideo_header">
      <div class="clipVideo_nameGroup">
        <span
          class="clipVideo_nameGroup--back text-break--custom"
          @click="backToClip"
          >ビデオクリップ一覧</span
        >
        <template v-if="tagName">
          <img src="@/assets/icons/ico_next.svg" />
          <span
            class="clipVideo_nameGroup--tag text-break--custom"
            @click="handleTag"
            >{{ tagName }}</span
          >
        </template>
        <img src="@/assets/icons/ico_next.svg" />
        <span class="clipVideo_nameGroup--name text-break--custom">{{
          clipName
        }}</span>

        <span v-ripple class="icon icon-pencil" @click="handleRename"></span>
        <div class="clipVideo_flex-gap"></div>
        <v-btn v-if="false" color="warning" class="clipVideo_report"
          ><span class="icon icon-campaign" />
          <h5>SECOMへ通報</h5></v-btn
        >
      </div>
    </div>
    <section
      class="clipVideo_scroll"
      :style="{ height: `${calcVideoHeight}px` }"
    >
      <div class="clipVideo_videos">
        <div ref="video" class="clipVideo_main">
          <VideoPlayback
            ref="videoRef"
            :muted="!speakerOnModel"
            :fragment-meta="fragmentMeta"
            :loading="processing"
            :live="live"
            :playing.sync="playing"
            :playback-rate.sync="playbackRate"
            :set-time="setTime"
            :show-error="isVideoError"
            :start-timestamp="startTimestamp"
            :end-timestamp="endTimestamp"
            @onMeta="handleMeta"
            @timestamp="timestamp = $event"
            @onVideoLength="handleVideoLength"
            @onError="handleErrorVideo"
            @canplaythrough="handleCanPlayThrough"
          >
            <template slot-scope="{ show, _class }">
              <VideoSeek
                v-if="displayVideoSeek"
                :v-show="show"
                fullscreen-mode
                :class="_class"
                :live="live"
                :playing.sync="playing"
                :playback-rate.sync="playbackRate"
                :timestamp="timestamp"
                :is-playback="true"
                :memory="videoSeekEvent"
                :events="eventList"
                :time-range="currentTimeRange"
                @setTime="getTime"
                @onSetTimeRange="handleSetTimeRange"
              />
            </template>
            <template v-slot:footer>
              <section v-show="!isVideoError" class="clipVideo_main-camname">
                <movie-file-svg />
                <h3>{{ cameraName }}</h3>
                <div class="clipVideo_flex-gap"></div>
                <audio-control
                  v-if="audioRecording"
                  ref="audio"
                  v-model="volumeLevelModel"
                  :speaker-on="speakerOnModel"
                  @onSpeakerOn="handleMuted"
                >
                  <template v-slot:activator="{ on, attrs, volume, menuOpen }">
                    <v-btn
                      text
                      color="secondary"
                      class="clipVideo_item"
                      v-bind="attrs"
                      :class="{
                        'clipVideo_item-small': true,
                        'menu-close': !menuOpen,
                      }"
                      v-on="on"
                    >
                      <speaker-on-svg
                        v-if="volume !== 0"
                        class="clipVideo_icon icon"
                        color="#37a34a"
                        size="20px"
                      />
                      <speaker-off-svg
                        v-else
                        class="clipVideo_icon icon"
                        color="#37a34a"
                        size="20px"
                      />
                      <div class="clipVideo_text">スピーカー</div>
                    </v-btn>
                  </template>
                </audio-control>
                <v-tooltip
                  v-else
                  bottom
                  content-class="videoControllers-speaker_tooltip "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      class="clipVideo_icon icon"
                      v-bind="attrs"
                      src="@/assets/img/ico_support_speaker.svg"
                      v-on="on"
                    />
                  </template>
                  <h2>音声非対応</h2>
                </v-tooltip>
              </section>
            </template>
          </VideoPlayback>
          <section v-if="clip" class="clipVideo_tools">
            <div class="clipVideo_dateTime">
              <span
                class="clipVideo--lable"
                :class="{ 'mr-0': clip.hoursLong }"
              >
                時刻
              </span>
              <span class="clipVideo--value">
                {{ clip.startDate | dateMs('YYYY/MM/DD', 'unix') }}
                {{ clip.startDate | dateMs('HH:mm:ss', 'unix') }} ({{
                  clip.duration
                }})
              </span>
            </div>
            <div class="clipVideo_description">
              <div class="clipVideo_description_group">
                <div class="clipVideo_description_event">
                  <span class="clipVideo--lable">イベント</span>
                  <span
                    v-if="clip.event"
                    class="clipVideo--value eventItem_types"
                  >
                    <event-label
                      v-if="clip.event !== '$area'"
                      :label="clip.event"
                    />
                  </span>
                </div>
              </div>
              <div class="clipVideo_description_action">
                <!--                <v-btn x-small :color="'text'" @click="dialogMoveOpen = true">-->
                <!--                  <span class="icon icon-move" />-->
                <!--                  <div class="clipVideo_action-text">移動する</div>-->
                <!--                </v-btn>-->
                <v-btn
                  x-small
                  :color="'text'"
                  :disabled="downloading"
                  @click="dialogDownloadOpen = true"
                >
                  <span class="icon icon-download" />
                  <div class="clipVideo_action-text">ダウンロード</div>
                </v-btn>
                <v-btn x-small :color="'text'" @click="dialogDeleteOpen = true">
                  <span class="icon icon-trash" />
                  <div class="clipVideo_action-text">削除</div>
                </v-btn>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div
        ref="gap"
        class="clipVideo_control-box-gap"
        :style="{ height: `${controlBoxGap}px` }"
      />
    </section>
    <div
      ref="seekWrapper"
      class="clipVideo_control-box"
      :class="{ ['clipVideo_control-box--active']: !processing }"
    >
      <VideoSeek
        v-if="displayVideoSeek && !isVideoError"
        ref="seek"
        class="clipVideo-controlbar"
        :live="live"
        :playing.sync="playing"
        :playback-rate.sync="playbackRate"
        :timestamp="timestamp"
        :is-playback="true"
        :memory="videoSeekEvent"
        :events="eventList"
        :video-ref="$refs.videoRef"
        :time-range="currentTimeRange"
        @setTime="getTime"
        @onSetTimeRange="handleSetTimeRange"
      />
    </div>
    <!-- Rename dialog -->
    <clip-rename-dialog
      title="名前を変更する"
      :loading="loadingRename"
      :open="dialogRenameOpen"
      :name="clipName"
      :clip-id="clipId"
      :maxlength="100"
      :input-case="'clipName'"
      @onClose="closeDialogRename"
      @onOk="handleRenameOk"
    />

    <!-- Download dialog -->
    <clip-dialog-a
      :open="dialogDownloadOpen"
      :title="'ダウンロード'"
      @onClose="closeDialogDownload"
    >
      <div class="clip_dialog-content">
        1件のデータを
        <br />選択してダウンロードします。
      </div>
      <template v-slot:actions>
        <v-btn
          class="clip_dialog-btn clip_dialog-cancel"
          color="text"
          :disabled="downloading"
          @click="closeDialogDownload"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="clip_dialog-btn clip_dialog-ok"
          color="primary"
          :loading="downloading"
          @click="handleDownloadOk(false)"
        >
          ダウンロード
        </v-btn>
      </template>
    </clip-dialog-a>
    <!-- Delete dialog -->
    <clip-dialog-a
      :open="dialogDeleteOpen"
      :title="'ダウンロード'"
      @onClose="closeDialogDelete"
    >
      <div class="clip_dialog-content">
        1件のデータを<br />
        完全に削除してもよろしいですか？
      </div>
      <template v-slot:actions>
        <v-btn
          class="clip_dialog-btn clip_dialog-cancel"
          color="text"
          @click="closeDialogDelete"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="clip_dialog-btn clip_dialog-delete"
          color="text"
          @click="handleDeleteOk"
        >
          削除する
        </v-btn>
      </template>
    </clip-dialog-a>
    <!-- Move to tag dialog -->
    <clip-move-dialog
      :loading="loadingMove"
      :open="dialogMoveOpen"
      :list="moveList"
      title="フォルダを移動する"
      ok-label="移動"
      @onClose="closeDialogMove"
      @onOk="handleMoveOk"
    />

    <!-- ----------------- -->
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />

    <!-- ----------------- -->
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState, mapActions } from 'vuex';
import VideoService from '@/services/video.service';
import VideoSeek from '@/components/Controlbar.vue';
import VideoPlayback from '@/components/VideoPlayback.vue';
import { playVideoClips } from '@/services/video-clip.service';
import VideoSeekMixin from '../../mixin/videoSeekMixin';
import ClipMoveDialog from '@/components/dialogs/ClipMoveDialog.vue';
const customParseFormat = require('dayjs/plugin/customParseFormat');
const duration = require('dayjs/plugin/duration');
dayjs.extend(duration);
dayjs.extend(customParseFormat);
import ClipDialogA from '@/components/dialogs/ClipDialogA.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';
import ClipRenameDialog from '@/components/dialogs/ClipInputDialog.vue';
import { MimeTypes } from '@/globals/enums';
import {
  deleteVideoClips,
  downloadVideoClips,
} from '@/services/video-clip.service';
import { cutClipName, downloadFromURL, fileNameFromUrl } from '@/utils/file';
import { dialogService } from '@/services/dialog.service';
import { getUnixFromSecomDate } from '@/utils/date';
import MovieFileSvg from '../icons/MovieFileSVG.vue';
import AudioControl from '@/components/AudioControl.vue';
import SpeakerOffSvg from '@/components/icons/SpeakerOffSVG.vue';
import SpeakerOnSvg from '@/components/icons/SpeakerOnSVG.vue';

export default {
  name: 'ClipVideo',
  components: {
    VideoSeek,
    VideoPlayback,
    ClipDialogA,
    ClipDialogMessage,
    ClipRenameDialog,
    ClipMoveDialog,
    MovieFileSvg,
    AudioControl,
    SpeakerOffSvg,
    SpeakerOnSvg,
  },
  mixins: [VideoSeekMixin],
  data() {
    return {
      retryCount: 0,
      loadingRename: false,
      volumeLevelModel: 0,
      oldVolume: 0,
      speakerOnModel: false,
      loadingVideoClips: false,
      downloading: false,
      mimeTypes: MimeTypes,
      videoService: new VideoService(),
      loading: false,
      live: false,
      videoUrl: '',
      captureMode: true,
      trimMode: false,
      playing: false,
      timestamp: null,
      startTimestamp: null,
      endTimestamp: null,
      dialogDownloadOpen: false,
      dialogDeleteOpen: false,
      dialogMoveOpen: false,
      dialogRenameOpen: false,
      dialogMessageText: null,
      videoSeekEvent: null,
      displayVideoSeek: false,
      isVideoError: false,
      style: {},
      initResize: false,
      resizeObserver: null,
      controlBoxGap: 10,
      headerSize: 125,
      calcVideoHeight: 125,
      videoContainerHeight: 1,
      loadingMove: false,
      deletingVideoClip: false,
      retryDownloads: 1,
      fragmentMeta: { fragments: [], totalFragments: 0 },
      downloadedFiles: [],
      currentTimeRange: 1,
    };
  },
  computed: {
    ...mapState({
      clip: (state) => state.video.videoClip,
      clipTags: (state) => state.video.clipTags,
      videoClips: (state) =>
        state.video.videoClips.map((item, index) => ({ ...item, index })),
      clipEvents: (state) => state.video.clipEvents,
      cameraList: (state) => state.common.cameraList,
      event: (state) => state.event.event,
      eventList: (state) => {
        const { clipEvents } = state.video;
        const parsedEventList = [];
        !!clipEvents &&
          clipEvents.forEach((event) => {
            if (event && event.eventStartDate && event.eventEndDate) {
              const parsedEvent = {};
              const startEventUnix = getUnixFromSecomDate(event.eventStartDate);
              const endEventUnix = getUnixFromSecomDate(event.eventEndDate);
              parsedEvent.startUnix = startEventUnix;
              parsedEvent.start = dayjs(startEventUnix).format(
                'YYYY-MM-DDTHH:mm:ss'
              );
              parsedEvent.endUnix = endEventUnix;
              parsedEvent.end = dayjs(endEventUnix).format(
                'YYYY-MM-DDTHH:mm:ss'
              );
              parsedEvent.eventId = event.eventId;
              parsedEvent.cameraId = event.cameraId;
              parsedEvent.title = event.eventMetaDatas[0].value;
              parsedEventList.push(parsedEvent);
            }
          });
        return parsedEventList;
      },
    }),
    moveList() {
      const list = [{ label: 'フォルダに入れない', id: 0 }];
      this.clipTags.forEach((tag) => {
        list.push({
          label: tag.name,
          id: tag.id,
        });
      });
      return list;
    },
    processing() {
      return this.loadingVideoClips || this.loading;
    },
    cameraName() {
      return this.camera?.name;
    },
    clipId() {
      return Number(this.$route.params.id);
    },
    tagId() {
      return this.$route.params.tag;
    },
    tag() {
      return this.tagId
        ? this.clipTags.find((item) => String(item.id) === String(this.tagId))
        : null;
    },
    clipName() {
      return this.clip ? this.clip.clipName : '';
    },
    tagName() {
      return this.tag ? this.tag.name : null;
    },
    fromClipPage() {
      return this.$route.params.fromClipPage;
    },
    cameraId() {
      return this.clip?.cameraId;
    },
    camera() {
      return (
        this.clip?.cameraId &&
        this.cameraList?.find((camera) => camera.id === this.clip.cameraId)
      );
    },
    audioRecording() {
      return this.camera?.capabilities?.audioRecording;
    },
  },
  watch: {
    clip: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (val && !this.fromClipPage) {
          this.playClipVideo(val);
        }
      },
    },
    volumeLevelModel(val) {
      this.handleVolume(val);
    },
  },
  async mounted() {
    if (this.$refs.seekWrapper) {
      this.resizeObserver = new ResizeObserver(
        this.handleVideoSeekResize
      ).observe(this.$refs.seekWrapper);
    } else {
      console.warn('[WARN] seekWrapper ref not found');
    }
    window.addEventListener('resize', this.handleVideoSeekResize);
    if (this.clipTags.length === 0) {
      await this.fetchClipTags();
    }
    if (this.clip && this.fromClipPage) {
      await this.playClipVideo(this.clip);
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.seekWrapper);
    }
    window.removeEventListener('resize', this.handleVideoSeekResize);
  },
  methods: {
    ...mapActions('video', [
      'fetchClipEvents',
      'fetchClipTags',
      'updateVideoClip',
      'changeVideoClip',
      'checkEmptyTagToDelete',
      'moveToTag',
      'removeClipById',
      'setSearchParams',
    ]),
    handleSetTimeRange(timeRange) {
      this.currentTimeRange = timeRange;
    },
    handleMeta() {
      // handle meta
    },
    handleCanPlayThrough() {
      this.retryCount = 0;
    },
    handleVolume(level) {
      this.$refs.videoRef.$refs.playerElement.volume = level / 10;
      this.oldVolume = level;
    },
    handleMuted(status) {
      this.speakerOnModel = status;
    },
    async deleteEmptyTag(tagId) {
      const tagIdToDelete = tagId
        ? tagId
        : this.clip.tags && this.clip.tags[0]
        ? this.clip.tags[0].id
        : null;
      if (tagIdToDelete) {
        const deleted = await this.checkEmptyTagToDelete({
          tagId: tagIdToDelete,
        });
        return deleted;
      }
      return false;
    },
    handleTag() {
      this.routerPush({
        name: 'clip',
        query: { tab: 0, tag: this.tagId },
      });
    },
    handleVideoSeekResize() {
      if (this.$refs.seekWrapper && this.$refs.video) {
        const layoutHeight = this.$refs.layout.clientHeight;
        this.controlBoxGap =
          this.$refs.seekWrapper.getBoundingClientRect().height;
        this.headerSize = this.$refs.header.clientHeight;
        this.videoContainerHeight =
          layoutHeight - this.controlBoxGap - this.headerSize;

        this.calcVideoHeight = layoutHeight - this.headerSize - 10;
      }

      // Set height to prevent from overlapping content
      const layoutHeight = this.$refs.layout?.clientHeight || 0;
      if (layoutHeight) {
        const maxWidth = Math.trunc((layoutHeight - 220) * 2);
        this.style = { maxWidth: maxWidth + 'px' };
      }
    },
    async handleErrorVideo({ error }) {
      ++this.retryCount;
      if (this.retryCount > 3) {
        this.isVideoError = true;
        console.error(error);
        return;
      }
      await this.playClipVideo(this.clip);
      console.log(this.$refs.videoRef.$refs.playerElement);
      this.$refs.videoRef.loadPlayer();
    },
    handleRename() {
      this.dialogRenameOpen = true;
    },
    async handleRenameOk(name) {
      try {
        this.loadingRename = true;
        await this.updateVideoClip({
          id: this.clipId,
          name: name,
          tagIds: this.tagId ? [this.tagId] : [],
        });
        this.loadingRename = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingRename = false;
      }
      this.dialogRenameOpen = false;
    },
    handleVideoLength() {
      // set video seek event
      const point = dayjs(this.clip.startDate);
      let start = point;
      let end = point.add(this.clip.durationMs, 'milliseconds');

      this.videoSeekEvent = {
        start: start.format('YYYY-MM-DDTHH:mm:ss'),
        end: end.format('YYYY-MM-DDTHH:mm:ss'),
      };
      this.displayVideoSeek = true;

      this.fetchClipEvents({
        start: start.subtract(10, 'seconds').format('YYYYMMDDHHmm00'),
        end: end.add(10, 'seconds').format('YYYYMMDDHHmm00'),
        cameraId: this.clip.cameraId,
      });
    },
    backToClip() {
      this.routerPush({ name: 'clip' });
    },
    async playClipVideo(clip) {
      try {
        this.loading = true;
        const res = await playVideoClips({ ids: clip.id });

        this.timestamp = clip.startDate;
        this.startTimestamp = clip.startDate;
        this.endTimestamp = clip.endDate;
        this.live = false;
        const eventStartDate = dayjs(clip.startDate);

        this.getTime(eventStartDate);
        if (!res.archives || res.archives?.length === 0) {
          throw new Error('The archives is undefined!');
        }

        if (res.archives.some((item) => item.status !== 2)) {
          throw new Error('Archive status is not satisfied!');
        }
        const fragments = [];
        const clips = res.archives
          .map((item) => item.urls)
          .flat()
          .filter((url) => url !== null)
          .map((clip, index) => [index, clip]);
        // const durations$ = [];
        if (clips.length === 0) {
          throw new Error('No URL!');
        }
        for (const [index, clip] of clips) {
          // durations$.push(getVideoDurationFromURL(clip.url));
          fragments.push({
            index,
            url: clip.url,
            // duration,
          });
        }
        // console.log(durations$);
        // const durations = await Promise.all(durations$);
        // console.log('durations', durations);

        if (fragments.length === 0) {
          throw new Error('No fragmnet received!');
        }

        this.$set(this.fragmentMeta, 'fragments', fragments);
        this.$set(this.fragmentMeta, 'totalFragments', fragments.length);
      } catch (error) {
        this.isVideoError = true;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    closeDialogDownload() {
      this.dialogDownloadOpen = false;
    },
    closeDialogRename() {
      this.dialogRenameOpen = false;
    },
    closeDialogDelete() {
      this.dialogDeleteOpen = false;
    },
    closeDialogMove() {
      this.dialogMoveOpen = false;
    },
    closeDialogMessage() {
      if (this.deletingVideoClip) {
        this.$router.push({
          name: 'clip',
        });
      }
      this.dialogMessageText = null;
    },
    async handleDownloadOk(retry = false) {
      if (!retry) {
        this.downloading = true;
        this.downloadedFiles = [];
      }
      try {
        const res = await downloadVideoClips(this.clipId.toString());
        if (res && res.archives && res.archives.length) {
          // Only download files with status === 2
          const validClipsToDownload = res.archives.filter(
            (clip) => clip.status === 2
          );
          if (validClipsToDownload.length) {
            const urlsToDownload = res.archives.map((item) => item.urls).flat();
            this.closeDialogDownload();
            !retry && (this.dialogMessageText = 'ダウンロードを開始しました。');
            const downloadSuccess = await this.handleDownloadAURLs(
              urlsToDownload,
              this.clipName
            );
            if (downloadSuccess) {
              this.retryDownloads = 1;
            }
          } else {
            this.showDownloadErrorDialog();
          }
        } else {
          this.showDownloadErrorDialog();
        }
      } catch (error) {
        console.log(error);
        this.showDownloadErrorDialog();
      } finally {
        this.downloading = false;
      }
    },
    async handleDownloadAURLs(urls, fileName) {
      if (!urls || !urls.length || urls.every((url) => url === null)) {
        this.showDownloadErrorDialog();
        return false;
      } else {
        try {
          const namingIndex = urls.length > 1;
          await Promise.all(
            urls
              .filter((url) => {
                return (
                  url !== null &&
                  !this.downloadedFiles.includes(fileNameFromUrl(url.url))
                );
              })
              .map(async ({ url }, index) => {
                // Naming files with part number
                const indexedName =
                  fileName + (namingIndex ? `-${index + 1}` : '');
                const finalName = cutClipName(indexedName, namingIndex);
                const downloadResult = await downloadFromURL(
                  url,
                  finalName,
                  true
                );
                if (downloadResult) {
                  // Checked successful downloads by file name
                  this.downloadedFiles.push(downloadResult.fileName);
                }
              })
          );
          if (this.downloadedFiles.length < urls.length) {
            // If urls have errors, retry downloads with new url
            await this.retryDownload('File(s) missing!');
          } else {
            this.downloading = false;
          }
          return true;
        } catch (error) {
          await this.retryDownload(error);
          return false;
        }
      }
    },
    showDownloadErrorDialog() {
      this.downloading = false;
      this.closeDialogDownload();
      dialogService.showErrorDialog(
        {
          title: ' ',
          content: `ビデオクリップ準備中のため<br>
              ダウンロードできませんでした。<br>
              お手数ですが、時間をおいて再度お試しください。`,
          cancel: false,
        },
        {
          classes: ['height-245'],
        }
      );
    },
    async retryDownload(error) {
      // Retry downloads with 3 attempts
      if (this.retryDownloads > 3) {
        this.retryDownloads = 1;
        console.log(`Cannot download (3 attempts): ${error}`);
      } else {
        console.log(
          `Error occurred (Retrying downloads-${this.retryDownloads}): ${error}`
        );
        this.retryDownloads++;
        await this.handleDownloadOk(true);
      }
    },
    async handleDeleteOk() {
      try {
        await deleteVideoClips({
          ids: [this.clipId],
        });
        this.closeDialogDelete();
        this.deletingVideoClip = true;
        this.dialogMessageText = 'データを削除しました';
      } catch (error) {
        console.error(error);
        this.deletingVideoClip = false;
      }
    },
    async handleMoveOk(tagId) {
      try {
        this.loadingMove = true;
        await this.moveToTag({
          clips: [this.clip],
          tagId,
        });
        await this.deleteEmptyTag(this.tagId);
        this.dialogMoveOpen = false;
        this.routerReplace({
          name: 'clip-detail',
          params: { id: this.clipId, tag: tagId },
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMove = false;
      }
    },
  },
};
</script>

<style lang="scss">
.clipVideo {
  &_pointer--disabled {
    pointer-events: none;
  }
  &_item {
    &_icon {
      margin-right: 5px;
    }
    &_text {
      font-weight: 600;
    }
    &.v-btn:not(.v-btn--round).v-size--default {
      height: 31px;
      padding: 0 5px;
    }
    &-small {
      font-size: 19px !important;
      min-width: 0 !important;
      padding: 0px 0px 0px 5px !important;
      .icon-3dots {
        margin-left: 0 !important;
      }
      .clipVideo_text {
        display: none;
      }
    }
  }
  &_tools {
    min-width: 235px;
    margin-left: 30px;
  }
  &_scroll {
    @include scrollBar;
    overflow-y: auto;
  }
  &_section {
    height: 100%;
  }
  .icon-pencil {
    margin-left: 10px;
    color: #989898;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  &_flex-gap {
    display: flex;
    flex: 1;
  }
  &_report {
    &.theme--light.v-btn.v-btn--has-bg {
      width: 116px;
      height: 26px;
      border-radius: 5px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #eb545b;
      font-size: 10px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
    }
    .icon-campaign {
      font-size: 14px;
      margin-right: 6px;
    }
    h5 {
      line-height: 1.6;
    }
  }
  &_control-box {
    position: absolute;
    background-color: #fff;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding: 7px 30px 20px 30px;
    z-index: 1;
    &--tools {
      max-height: 246px;
      padding: 4px 30px 7px 30px;
    }
    &--active {
      box-shadow: 0px -5px 7px -3px rgb(0 0 0 / 32%);
    }
    &-gap {
      min-height: 10px;
    }
  }
  &_trim {
    &-transition {
      position: absolute;
      z-index: 3;
    }
  }
  &_selected-capture {
    .videoStream_video {
      border: solid 3px #0075c2;
    }
  }
  &_selected-trim {
    .videoStream_video {
      border: solid 3px #37a34a;
    }
  }
  &_hide {
    visibility: hidden;
    & > * {
      visibility: hidden !important;
    }
  }
  &_drop {
    background-color: #f3f3f3;
  }
  &_videoStream {
    height: 100%;
  }
  &_divider {
    height: 10px;
  }
  &_invisible {
    visibility: hidden !important;
    width: 0px !important;
    position: absolute !important;
  }
  &_no-data-cameras {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: #8c8c8a85;
  }

  &_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      line-height: 27px;
      font-weight: 700;
      &-event {
        color: rgba(0, 0, 0, 0.4);
      }
      &-trim {
        color: #37a34a;
      }
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
    min-height: 300px;
    padding: 0px 30px 0px 30px;
  }
  &_main {
    display: flex;
    overflow: hidden;
    position: relative;
    &-event {
      &:before {
        border: 4px solid var(--accent-color);
      }
    }
    .videoStream_video {
      // min-height: 215px;
      video {
        vertical-align: bottom;
      }
    }
    &-camname {
      display: flex;
      margin-top: 5px;
      align-items: center;
      h3 {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        margin-left: 5px;
      }
    }
  }
  &_edit {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;
    align-items: baseline;
    &-left {
      flex-grow: 1;
      flex-shrink: 0;
      margin-right: 30px;
    }
    &-right {
      flex-grow: 0;
      flex-shrink: 0;
      margin-left: 30px;
      .v-btn {
        width: 120px;
        font-size: 14px !important;
        font-weight: bold;
      }
    }
    &-camtext {
      font-size: 12px;
      font-weight: bold;
      line-height: 1.08;
      color: #989898;
      margin-right: 10px;
    }
    &-cambtn {
      margin-right: 10px;
    }
    &-shootbtn {
      margin-left: 10px;
    }
  }
  .clipVideo {
    &_header {
      display: flex;
      flex-direction: column;
      padding: 30px 30px 0px 30px;

      .clipVideo_nameGroup {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        &--back {
          cursor: pointer;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #4b4b4b;
          margin-right: 5px;
        }
        &--name {
          font-size: 14px;
          font-weight: bold;
          color: #4b4b4b;
        }
        &--tag {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #4b4b4b;
          margin-right: 5px;
          cursor: pointer;
        }
        img {
          margin-right: 5px;
        }
      }
      .clipVideo_dateTime {
        margin-bottom: 10px;
      }
    }
    &_action {
      &-text {
        font-size: 10px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #0075c2;
      }
    }
    &_description {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      flex-direction: column;
      margin-top: 10px;

      &_group {
        display: flex;
      }
      &_camera {
        display: flex;
        align-items: center;
        margin-right: 30px;
      }
      &_event {
        display: flex;
        align-items: center;
      }
      &_action {
        display: flex;
        flex-direction: column;

        button {
          &.v-btn:not(.v-btn--round).v-size--x-small {
            margin-top: 10px;
            width: fit-content;
            padding: 0 6px;
            min-width: 0;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
            &:first-child {
              margin-top: 16px;
            }
          }
        }
      }
    }
    &--lable {
      font-size: 12px;
      font-weight: normal;
      color: #989898;
      margin-right: 10px;
      white-space: nowrap;
      min-width: 50px;
      display: inline-block;
    }
    &--value {
      font-size: 12px;
      font-weight: 600;
      color: #4b4b4b;
    }
  }
  &.fullscreen {
    button {
      width: 45px !important;
      height: 45px !important;
      &.videoSeek_vod_liveToggle-btn {
        width: auto !important;
        height: auto !important;
      }
    }
    .videoSeek_vod_liveToggle {
      height: auto !important;
      &--content {
        padding: 14px 15px;
        display: flex;
        position: relative;
        cursor: pointer;
        .v-btn__content {
          line-height: 1;
        }
        &:hover {
          &::before {
            opacity: 0.08;
            background-color: currentColor;
            border-radius: inherit;
            bottom: 0;
            color: inherit;
            content: '';
            left: 0;
            pointer-events: none;
            position: absolute;
            right: 0;
            top: 0;
            transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
            border-radius: 5px;
          }
        }
      }
    }
    .vue-slider {
      padding: 0px 20px !important;
      cursor: pointer;
    }
    .videoSeek_vod_controls {
      width: auto;
    }
    .slider_icon {
      padding: 12px !important;
    }
    .controlbar_vod_speed {
      .v-input__slot {
        padding: 4px;
      }
    }
  }
}
</style>
